import $ from 'jquery';
import { $window, $wrapper, breakpoint } from '../variables/variables.js';
import { debounce } from '../functions/functions.js';
import loader from '../loader/loader.js';
import * as page from '../page/page.js';
import { $header } from '../header/header.js';



$( () => {
	const $body       = $( 'html, body' );
	const $filter     = $( '.catalog__filter' );
	const $row        = $( '.catalog__row' );
	const $order      = $( '.select_sort .select__input' );
	const $count      = $( '.catalog__count' );
	let   $pagination = $( '.pagination' );

	if ( ! $( '.catalog' ).length ) {
		return;
	}

	const defaultState = {
		params:         getParams(),
		count:          $count.text(),
		rowHTML:        $row.prop( 'outerHTML' ),
		paginationHTML: $pagination.prop( 'outerHTML' ),
	};

	function getParams() {
		const params = $filter.serializeArray();
		
		params.push( {
			name:  $order.attr( 'name' ),
			value: $order.val(),
		} );

		return params;
	}

	function update( state ) {
		if ( state.paginationHTML ) {
			$pagination.removeClass( 'hidden' );

			if ( ! $pagination.length ) {
				$pagination = $( state.paginationHTML );
				$row.after( $pagination );
			}
		} else {
			$pagination.addClass( 'hidden' );
		}
		$pagination.html( $( state.paginationHTML ).html() );

		$count.text( state.count );
		$row.children( '.catalog__col' ).remove();
		$row.append( $( state.rowHTML ).children( '.catalog__col' ) );

		state.params.forEach( ( param ) => {
			$( '[name="' + param.name + '"]' ).val( param.value ).trigger( 'update' );
		} );
	}

	function load( url ) {
		$.get( url, loader( $row.add( $filter ), ( html ) => {
			const $html = $( html );

			const state = {
				params:         getParams(),
				count:          $html.find( '.catalog__count' ).text(),
				rowHTML:        $html.find( '.catalog__row' ).prop( 'outerHTML' ),
				paginationHTML: $html.find( '.pagination' ).prop( 'outerHTML' ),
			};

			history.pushState( state, null, url );
			update( state );
		} ) );
	}

	// Обновить контент страницы
	$filter.on( 'change', () => {
		load(
			location.href.split( '?' )[0].replace( /page\/(.*?)\//, '' ) + '?' +
			$.param( getParams().filter( item => item.value ) )
		);
	} );

	// Сбросить фильтр
	$( '.catalog__filter-button_reset' ).on( 'click', () => {
		$filter.find( '.field__number_price, .select__input' ).val( '' ).trigger( 'change' );
	} );

	// Сортировка
	$order.on( 'change', () => {
		$filter.trigger( 'change' );
	} );

	// Пагинация
	$pagination.on( 'click', '.pagination__link[href], .pagination__arrow[href]', function( e ) {
		const $top = breakpoint.isTablet ? $( '.catalog__header-top' ) : $filter;

		e.preventDefault();
		load( $( this ).attr( 'href' ) );
		$body.animate( { scrollTop: $top.offset().top + $top.innerHeight() - $header.outerHeight() } );
	} );

	// Изменение контента при переходе по истории браузера
	window.addEventListener( 'popstate', ( e ) => {
		update( e.state ? e.state : defaultState );
	} );

	// Открыть фильтр на мобильном
	$( '.catalog__filter-button_open' ).on( 'click', () => {
		page.scrollOff();
		$filter.addClass( 'catalog__filter_active' );
	} );

	// Закрыть фильтр на мобильном
	$( '.catalog__filter-close, .catalog__filter-button_show' ).on( 'click', () => {
		page.scrollOn();
		$filter.removeClass( 'catalog__filter_active' );
	} );

	// Закрыть фильтр на мобильном при клике снаружи
	$wrapper.on( 'click', ( e ) => {
		if ( ! $( e.target ).closest( '.catalog__filter-box, .catalog__filter-button_open' ).length ) {
			page.scrollOn();
			$filter.removeClass( 'catalog__filter_active' );
		}
	} );

	// Включить/отключить прокрутку страницы при изменении ширины окна
	$window.on( 'resizeWidth', debounce( () => {
		const IS_ACTIVE_FILTER         = $filter.hasClass( 'catalog__filter_active' );
		const IS_ENABLE_SCROLL_DESKTOP = ( IS_ACTIVE_FILTER && ! page.isScroll && ! breakpoint.isTablet );
		const IS_DISABLE_SCROLL_MOBILE = ( IS_ACTIVE_FILTER && page.isScroll && breakpoint.isTablet );

		if ( IS_ENABLE_SCROLL_DESKTOP ) {
			page.scrollOn();
		}

		if ( IS_DISABLE_SCROLL_MOBILE ) {
			page.scrollOff();
		}
	} ) );
} );
